import React from "react";
import Game from "components/game";
import Document from "components/document";
import { useBreadCrumbs } from "components/use-hooks";
import { Localize } from "components/service";
import { GET_GAMES, GET_GAMES_ORDER } from "graphql/query/game-gql";
import { GET_DOCUMENTS, GET_DOCUMENTS_ORDER } from "graphql/query/document-gql";
import SettingsAppSection from "./settings-app-section";
import "./settings-app.scss";

const SettingsAppSubPage = () => {
    useBreadCrumbs([
        { label: Localize({ children: "BREADCRUMBS.Label_Settings" }).props.children, path: "/settings" },
        { label: "App", path: "/settings" },
    ]);

    return (
        <div className="app-settings">
            <SettingsAppSection
                model="games" query={GET_GAMES} entityProp="game" EditForm={Game.Forms.Edit}
                orderQuery={GET_GAMES_ORDER} useOrderMutation={Game.Hooks.order}
                title="APP_SETTINGS.Title_Games" emptyText="APP_SETTINGS.Empty_Games" addText="APP_SETTINGS.Add_Game"
            />
            <SettingsAppSection
                model="documents" query={GET_DOCUMENTS} entityProp="document" EditForm={Document.Forms.Edit}
                orderQuery={GET_DOCUMENTS_ORDER} useOrderMutation={Document.Hooks.order}
                title="APP_SETTINGS.Title_Documents" emptyText="APP_SETTINGS.Empty_Documents" addText="APP_SETTINGS.Add_Document"
            />
        </div>
    );
};

export default SettingsAppSubPage;
